<!-- no template tag -->
<script>
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
    name: 'UiDonutChart',
    extends: Doughnut,
    mixins: [reactiveProp],
    props: {
        options: {
            type: Object,
            default: function () {
                return null;
            }
        },
        centerText: {
            type: Array,
            default: function () {
                return [];
            }
        },
    },
    mounted: function () {
        this.addPlugin({
            afterDatasetsDraw: function (chart) { // draw centerText
                let ctx = chart.ctx;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                let defaultFont = Chart.defaults.global;
                for (let textOption of this.centerText) {
                    let fontText = textOption.text || '';
                    if (!fontText) continue;
                    let fontSize = textOption.size || defaultFont.defaultFontSize;
                    let fontColor = textOption.color || defaultFont.defaultFontColor;
                    let fontFamily = textOption.family || defaultFont.defaultFontFamily;
                    let fontStyle = textOption.style || defaultFont.defaultFontStyle;
                    let fontX = textOption.x || 0;
                    let fontY = textOption.y || 0;

                    ctx.fillStyle = fontColor;
                    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                    ctx.fillText(fontText, chart.width / 2 + fontX, chart.height / 2 + fontY);
                };
            }.bind(this)
        });
        this.renderChart(this.chartData, this.options);
    },
}
</script>